import "./bannersection.css";
import heroImage from "../images/heroImage.svg";
import heroImageMobile from "../images/heroImageMobile.svg";
import APIDocsForm from "./Modals/ApiDocsForm/APIDocsForm";
import { isMobile } from "../utility/constand";
import { useState } from "react";

const BannerSection = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const backgroundImage = isMobile ? heroImageMobile : heroImage;

  return (
    <div
      className="banner-section"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="banner-section-content">
        <h1 className="banner-section-heading">The API Platform</h1>
        <p className="banner-section-main-text">
           For End-to-End ID Verification
        </p>
        <p className="banner-section-text">
          Verify identities in seconds, meet compliance requirements, and stop fraud: without adding complexity.
        </p>
        <div className="buttons">
          <button className="api-doc" onClick={() => setModalOpen(true)}>
            View API Documentation
          </button>
          {/* <button className="talk-us">Talk to Us</button> */}
        </div>
      </div>
      <APIDocsForm
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        key={"modal"}
      />
    </div>
  );
};

export default BannerSection;
